import type { ReactNode } from 'react'
import css from './SidebarUiButton.module.css'
import {TextNorm} from "../../../../ui/Text";

interface SidebarUiButtonProps {
    icon: ReactNode
    title: string
    isActive?: boolean
    // Optional right-aligned indicator (e.g. a menu chevron) — only rendered in
    // the mobile sidebar via CSS; the desktop sidebar shows just the icon.
    rightIcon?: ReactNode
    onClick?: () => void
    testId?: string
}

const SidebarUiButton = ({ icon, title, isActive, rightIcon, onClick, testId }: SidebarUiButtonProps) => {
    return (
        <button className={`${css.button} ${isActive ? css.active : ''}`} onClick={onClick} data-testid={testId}>
            <span className={css.icon}>{icon}</span>
            <TextNorm className={css.title}>{title}</TextNorm>
            {rightIcon && <span className={css.rightIcon}>{rightIcon}</span>}
        </button>
    )
}

export default SidebarUiButton
